
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CompanyEnum } from '../enums/company-enum.model';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

    private logoLight = 'logo-light.png';
    private logoDark = 'logo-dark.png';
    private totImages = 'assets/images/';
    private teachImages = 'assets/teach-images/';
    private totCompanyName = 'TEACHERS OF TOMORROW';
    private teachCompanyName = '#TEACH';
    private totTitle = 'Field Supervisor Portal';
    private teachTitle = 'Instructional Coach Portal';

    public theme: string;
    public logoLightUrl: string = this.totImages + this.logoLight;
    public logoDarkUrl: string = this.totImages + this.logoDark;
    public companyName: string = this.totCompanyName;
    public portalTitle: string = this.totTitle;

    constructor() {
        this.setTheme(CompanyEnum.Tot);
    }

    private logoSubject = new BehaviorSubject<{ light: string, dark: string, companyName: string, portalTitle: string }>({
        light: this.logoLightUrl,
        dark: this.logoDarkUrl,
        companyName: this.companyName,
        portalTitle: this.portalTitle
    });
    logo$ = this.logoSubject.asObservable();

    setTheme(companyId: number) {
        switch (companyId) {
            case CompanyEnum.Teach:
                this.theme = 'teach-theme';
                this.logoLightUrl = this.teachImages + this.logoLight;
                this.logoDarkUrl = this.teachImages + this.logoDark;
                this.companyName = this.teachCompanyName;
                this.portalTitle = this.teachTitle;
                document.body.className = this.theme;
                break;
            case CompanyEnum.Tot:
            default:
                this.theme = 'tot-theme';
                this.logoLightUrl = this.totImages + this.logoLight;
                this.logoDarkUrl = this.totImages + this.logoDark;
                this.companyName = this.totCompanyName;
                this.portalTitle = this.totTitle;
                document.body.className = this.theme;
                break;
        }
        document.body.className = this.theme;
        this.logoSubject.next({ light: this.logoLightUrl, dark: this.logoDarkUrl, companyName: this.companyName, portalTitle: this.portalTitle });
    }
}
